export const SHOW_SIDEBAR = "SHOW_SIDEBAR";
export const CHANGE_THEME = "CHANGE_THEME";
